/**
 * Route names defined for routes that are
 * a part of organizer app, without header and footer
 * and are mostly called by backend.
 *
 * These routes are mostly for getting PDFs and printing
 * tickets/summaries, while sharedRouteNames are mostly
 * routes that lead to some interactive pages, for example login,
 * signup, forgot pass...
 */
export const ungroupedRouteNames = {
  print: 'print',
  ticketPdf: 'ticketPdf',
  maintenanceScreen: 'maintenanceScreen',
  bulkPrint: 'bulkPrint',
  eventSummaryPdf: 'eventSummaryPdf',
  calculationPdf: 'calculationPdf',
  calculationPdfSport: 'calculationPdfSport',
  theaterEventReport: 'theaterEventReport',
  compensationPdf: 'compensationPdf',
  compensationPdfSport: 'compensationPdfSport',
  inviteAccreditation: 'invite-accreditation',
  ticketSellerPrintContainer: 'ticketSellerPrintContainer',
  invoicepdf: 'invoicePdf',
  reportPdfAdmin: 'ticket-seller-admin-report-pdf',
  compensationPdfTicketSeller: 'ticket-seller-admin-compensation',
  eventPreview: 'event-preview',
  googleOAuthCallback: 'google-oauth-callback',
  theaterAdminReport: 'theater-admin-report',
  insuranceWithdrawal: 'insurance-withdrawal',
}
